// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__IUd84","plus":"button_plus__2jVdA","initials":"button_initials__Mr3ZX","plusSign":"button_plusSign__FFwl-","text":"button_text__jURfO"};